<template lang="html">
  <div class="evaluate-list">
    <commentItem
      v-for="comment in items"
      :comment="comment"
      :key="comment.id"
      :imgLog="true"
    ></commentItem>
  </div>
</template>

<script>
import commentItem from './item'

export default {
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  components: {
    commentItem
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/mixin';
</style>
